import React from 'react';
import { addPrefixPath } from '@serpro/volto-prefixpath/helpers/Url/Url';
import cx from 'classnames';
import { DateInfo } from 'govbr.frontend.policy/components';
import TagsUFs from 'govbr.frontend.policy/components/TagsUFs';
import { parseCategory } from 'govbr.frontend.policy/helpers';
import { messages } from 'govbr.frontend.policy/messages/audio';
import { useIntl } from 'react-intl';

import styles from './Listing.module.less';
import { Category, Description, Title } from './ListingParts';

export const Audio = ({ item, isEditMode }) => {
  const intl = useIntl();
  const audioFile = item?.audio_file;
  const audioType =
    audioFile?.contentType ||
    audioFile?.content_type ||
    audioFile?.['content-type'] ||
    'audio/mpeg';
  const downloadUrl = audioFile?.download
    ? addPrefixPath(audioFile.download)
    : null;
  let category = item?.category_title || item?.category;
  if (category && typeof category === 'object') {
    category = parseCategory(item?.category);
  }

  return (
    <div className={cx(styles.body, styles.audio)}>
      <Title item={item} isEditMode={isEditMode} />
      <Description item={item} />
      <Category category={category} />
      <DateInfo item={item} />
      <TagsUFs
        className={'mt-1 mt-sm-0'}
        content={{
          subjects: item?.subjects || item?.Subject,
        }}
      />
      {downloadUrl && (
        <div
          className={cx(
            styles.thumbWrapper,
            styles.audioWrapper,
            'mt-2 mt-sm-0',
          )}
        >
          {
            // Media elements such as <audio> and <video> must have a <track> for captions
            // eslint-disable-next-line jsx-a11y/media-has-caption
            <audio controls className={styles.audioPlayer}>
              <source src={downloadUrl} type={audioType} />
              {intl.formatMessage(messages.audioUnsupported)}
            </audio>
          }
        </div>
      )}
    </div>
  );
};
